import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { MdMessage } from "react-icons/md";
import * as yup from "yup";
import useAxios from "axios-hooks";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { activeConnectorState } from "atoms/activeConnectorState";
import { toastState } from "atoms/toastState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";

//import { TbMessage } from "react-icons/tb";

const ChangeAvailability = ({ refresh, connector: connectorProp, inline = false }) => {
  const activeConnectorFromState = useRecoilValue(activeConnectorState);
  const activeConnector = connectorProp ?? activeConnectorFromState;
  const setToast = useSetRecoilState(toastState);
  const [{ data, loading, error }, execute] = useAxios(
    { method: "POST", url: "/api/ocpp16/changeAvailability" },
    { manual: true }
  );
  const validationSchema = yup.object().shape({
    Type: yup.string().required("Please Select IdTag"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const controllers = [
    {
      name: "Type",
      label: "Type",
      type: "select",
      helperText: "Select Operative/InOperative",
    },
  ].map((el, ind) => {
    const options = ["Inoperative", "Operative"].map((ele, index) => {
      return (
        <option value={ele} key={index}>
          {ele}
        </option>
      );
    });
    return (
      <Controller
        key={ind}
        name={el.name}
        control={control}
        render={({ field }) => (
          <FormControl as="fieldset" maxW="100%" isInvalid={errors[el.name]}>
            <FormLabel as="legend" fontSize="sm" fontWeight={600} mb={1}>
              {el.label}
            </FormLabel>
            {el.type === "select" && (
              <Select required placeholder="Select Availability" {...field} fontSize="sm" h="38px" borderRadius="lg" border="1px solid rgba(245, 125, 54, 0.25)">
                {options}
              </Select>
            )}
            <FormHelperText>{el?.helperText}</FormHelperText>
            <FormErrorMessage mb={"20px"}>
              {errors[el.name] && errors[el.name].message}
            </FormErrorMessage>
          </FormControl>
        )}
      />
    );
  });

  const operation = async () => {
    const formValues = getValues();
    let body = {};
    body["EvseSerialId"] = activeConnector?.EvseSerialId;
    body["Availability"] = formValues.Type;
    body["StationId"] = activeConnector?.EvseId;
    try {
      const response = await execute({ data: body });
      setToast({
        isOpen: true,
        title: "Availability Changed",
        description: response.data.data.Message,
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      logger.log(error);
      setToast({
        isOpen: true,
        title: "Error occured when changing Availability",
        description: err ? err : null,
        status: "error",
      });
    }
    refresh();
  };
  const content = (
    <>
      <Text fontWeight={700} fontSize="sm" color="gray.700" mb={2.5}>
        Change Availability
      </Text>
      <Stack spacing={2.5} mb={3} w="100%">
        {controllers}
      </Stack>
      <Button
        alignSelf="flex-end"
        borderRadius="md"
        size="sm"
        h="36px"
        fontSize="sm"
        textColor={"white"}
        backgroundColor="#f57d36"
        _hover={{ backgroundColor: "whatsapp.600" }}
        rightIcon={<MdMessage size={13} />}
        onClick={handleSubmit(operation)}
        isLoading={loading}
      >
        Update Availability
      </Button>
    </>
  );

  return loading ? (
    <LoadingSpinner />
  ) : inline ? (
    <Stack align="stretch">{content}</Stack>
  ) : (
    <Card alignItems="stretch" pt={0} px={0} pb={0}>
      {content}
    </Card>
  );
};

export default ChangeAvailability;
